// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"169":"b0b745f3","453":"bcfef4f4","640":"54d7dfb6"}[chunkId] + ".chunk.js");